// @flow

import endpoints from "./endpoints";

import { bubaClientAuth, bubaClient } from ".";

export type RefreshPassword = (
  oldPassword: string,
  password: string,
  passwordConfirmation: string,
  token: string
) => Promise<*>;

export const logIn = (payload: { email: string, password: string, scope: string }) =>
  bubaClientAuth({
    validateStatus: status => status < 300 || status === 401,
    method: "post",
    url: endpoints.logIn(),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.api+json"
    },
    data: {
      username: payload.email,
      password: payload.password,
      scope: payload.scope,
      grant_type: "password"
    }
  });

export const logOut = (token: string) =>
  bubaClientAuth({
    validateStatus: status => status < 300 || status === 401 || status === 403,
    method: "post",
    url: endpoints.logOut(),
    headers: { "Content-Type": "multipart/form-data" },
    data: `token=${token}`
  });

export const refreshPassword = (
  oldPassword: string,
  password: string,
  passwordConfirmation: string,
  token: string
) =>
  bubaClient({
    validateStatus: status => status === 204,
    method: "patch",
    url: endpoints.changePassword(),
    headers: {
      "Content-Type": "application/vnd.api+json",
      Accept: "application/vnd.api+json",
      Authorization: `Bearer ${token}`
    },
    data: {
      old_password: oldPassword,
      password,
      password_confirmation: passwordConfirmation
    }
  });

export const requestPasswordReset = (payload: { email: string }) =>
  bubaClient({
    validateStatus: status => status === 204,
    method: "patch",
    url: endpoints.requestPasswordReset(),
    data: payload
  });

export const resetPassword = (payload: {
  reset_password_token: string,
  password: string,
  password_confirmation: string
}) =>
  bubaClient({
    validateStatus: status => status === 204,
    method: "patch",
    url: endpoints.resetPassword(),
    data: payload
  });

export const activatePassword = (payload: {
  activation_token: string,
  password: string,
  password_confirmation: string,
  phone_number: string
}) =>
  bubaClient({
    validateStatus: status => status === 204,
    method: "patch",
    url: endpoints.activatePassword(),
    data: payload
  });

export const getTokenInfo = token =>
  bubaClientAuth({
    validateStatus: status => status < 300 || status === 401,
    url: endpoints.tokenInfo(),
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

export const getFeatureFlags = featureFlagNames =>
  bubaClient({
    validateStatus: status => status === 200,
    url: endpoints.getFeatureFlags(featureFlagNames)
  });

export const refreshBubaToken = () =>
  bubaClientAuth({
    validateStatus: status => status === 200,
    method: "post",
    url: endpoints.logIn(),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.api+json"
    },
    withCredentials: true,
    data: {
      grant_type: "refresh_token"
    }
  });
